<mat-menu #userMenu="matMenu" class="loren-user-menu">
  <div class="loren-user-menu">
    @if(inAdminApp$ | async) {
    <button
      mat-menu-item
      class="loren-user-menu-item"
      [routerLink]="[appRoute]">
      <span class="loren-user-menu-item-text">{{
        "user.app" | transloco
      }}</span>
    </button>
    } @if((inAdminApp$ | async) === false) {
    <button
      *lorenShowForRoles="[
        userRoles.ADMIN,
        userRoles.ADMIN_READ,
        userRoles.COMPANY_ADMIN,
        userRoles.CHANNEL_ADMIN,
        userRoles.CHANNEL_ADMIN_READ
      ]"
      mat-menu-item
      class="loren-user-menu-item"
      (click)="handleAdminClick()">
      <span class="loren-user-menu-item-text">{{
        "user.administration" | transloco
      }}</span>
    </button>
    }
    <button
      mat-menu-item
      class="loren-user-menu-item"
      routerLinkActive="active-link"
      [routerLink]="[userProfileRoute]">
      <span class="loren-user-menu-item-text">{{
        "user.profile" | transloco
      }}</span>
    </button>
    <mat-divider></mat-divider>
    <button class="loren-user-menu-item" mat-menu-item (click)="handleLogout()">
      <span class="loren-user-menu-item-text">{{
        "user.logout" | transloco
      }}</span>
    </button>
  </div>
</mat-menu>

<div
  class="loren-user-menu-button-container"
  [tourAnchor]="userProfileAnchor"
  [matMenuTriggerFor]="userMenu"
  [matTooltip]="'tooltips.profile_access' | transloco">
  <button
    aria-label="User menu"
    class="loren-user-menu-button"
    [ngClass]="{ 'no-mat-btn-padding': userInfo()?.image }">
    @if(userInfo()?.image) {
    <img class="profile-pic" alt="profile-picture" [src]="userInfo().image" />
    } @else {
    <mat-icon class="loren-user-menu-button-icon">account_circle</mat-icon>
    }
  </button>
  @if(!isHandset) {
  <span class="loren-user-menu-button-text">
    {{ userDisplayName() }}
  </span>
  }
</div>
